import React, { useState } from "react";
import Header from "./LayoutIntro/Header";
import Sidebar from "./LayoutIntro/Sidebar";
import FooterIntro from "./LayoutIntro/FooterIntro";
import LokalaiInfo from "./aboutComponent/LokalaiIntro";
import OurStory from "./aboutComponent/ourStory";
import MissionSection from "./aboutComponent/MissionSeciton";
import WhyUs from "./aboutComponent/Whyus";
import GetInTouchSection from "./contactComponent/GetinTouch";
import OfficeLocations from "./contactComponent/OfficeLocation";
import Promotion from "./contactComponent/Promotion";

const Contact = () => {
  return (
    <>
      <GetInTouchSection />
      <OfficeLocations />
      <Promotion />
    </>
  );
};

export default Contact;
